export default __webpack_public_path__ + "static/industry-leader-97b469a81e7fa01b6b889ca0b8364f51.webp";